import moment from 'moment';
import {RepositoryFactory} from '../api/RepositoryFactory'
const SlotsRepo = RepositoryFactory.get('slots')
const SlotsRepoPost = RepositoryFactory.post('slots')
const SettingsRepoPost = RepositoryFactory.post('settings')

export const mixin = {
	data(){
		return{
			booleanOptions: [
				{ text: 'Yes', value: 1 },
				{ text: 'No', value: 0 }
			]
		}
	},
	methods: {
		async updateSgSetting(storeId, setting, newValue){		
			var sgpayload = new FormData();		
			sgpayload.append('storeId', storeId)
			sgpayload.append('setting', setting)
			sgpayload.append('newValue', newValue)
			await SettingsRepoPost.postUpdateSgSetting(sgpayload)			
		},
		isLetterNumber(value){
			var letterNumber = /^[0-9a-zA-Z]+$/;
			if(value.match(letterNumber)) 
			{
				return true
			}
			else
			{ 
				return false
			}
		},
			// Add a CSS class to mark a slot as unavailable if it is earlier than the minimum time delay required for a same day booking (based on settings sameDayOffset value)
		setClass(slotStatus, slotTime, slotDate){
			let currentHour = moment().get('hour');
			// Convert the slotTime text value to a numercial value that we can use to check against the sameDayOffset
			var slotHour = slotTime.substr(0, slotTime.indexOf(':'));  // get the first/second digit from the time string
			let slotPeriod = slotTime.slice(-2); // value will be  am or pm
			if (slotPeriod == "pm" && slotHour != 12) // add 12 hours to convert to 24 hour clock if pm 
			{
				slotHour = parseInt(slotHour) +  12;
			}
			let statusClass = slotStatus
			if(slotDate ==  moment().format("YYYY-MM-DD"))  //  moment().add(1, "day").format("YYYY-MM-DD") ADDIING A DAY IS ONLY REQUIRED FOR TESTING
			{
				statusClass = (slotHour  >= (currentHour - this.$store.state.sameDayOffset))? slotStatus: 'Same-Day'; 
			}
	
			return statusClass;
		},
		getDay(index, type){
			if(type == "clickandcollect")
			{
				this.fetchGetClickAndCollectSlots(index)
			}
			else if(type == "locker")
			{
				this.fetchGetLockerSlots(index)
			}
			else
			{
				this.fetchGetDeliverySlots(index)
			}
		},
		async fetchGetClickAndCollectSlots(index){
			const {data} =	await SlotsRepo.getClickAndCollectSlots()
			this.slots = data[index]			
		},
		async fetchGetLockerSlots(index){
			const {data} =	await SlotsRepo.getLockerSlots()
			this.slots = data[index]
		},
		async fetchGetDeliverySlots(index){
			const {data} =	await SlotsRepo.getDeliverySlots()
			this.slots = data[index]
		},
		async fetchGetClickAndCollectSlotsDesktop(){
			const {data} =	await SlotsRepo.getClickAndCollectSlots()
		
			this.weekOneDateRange = moment(data[0][0].slotDate).format('D MMM') + " to " + moment(data[6][0].slotDate).format('D MMM')
			this.weekTwoDateRange = moment(data[7][0].slotDate).format('D MMM') + " to " + moment(data[13][0].slotDate).format('D MMM')
			this.weekThreeDateRange = moment(data[14][0].slotDate).format('D MMM') + " to " + moment(data[20][0].slotDate).format('D MMM')
			this.weekFourDateRange = moment(data[21][0].slotDate).format('D MMM') + " to " + moment(data[27][0].slotDate).format('D MMM')
			this.weekOneData = data.slice(0, 7)
			this.weekTwoData = data.slice(7, 14)
			this.weekThreeData = data.slice(14, 21)
			this.weekFourData = data.slice(21)
		},
		async fetchCoreSlots(){
			this.coreWeekData = [];
		
			const {data} =	await SlotsRepo.getCoreSlots()			
				let mon = [];
				let tue = [];
				let wed = [];
				let thu = [];
				let fri = [];
				let sat = [];
				let sun = [];	
				
			// param 1 of the slice function is the start position of the slice, param 2 is the end index 
			// but the sliced array does not include the value at that index)
			switch(this.viewTypeSelected)
			{
				case 'clickandcollect':
				mon = data.slice(0, 24);
				tue = data.slice(24, 48);
				wed = data.slice(48, 72);
				thu = data.slice(72, 96);
				fri = data.slice(96, 120);
				sat = data.slice(120, 144);
				sun = data.slice(144, 168);
				break;
				case 'locker':
				mon = data.slice(168, 192);
				tue = data.slice(192, 216);
				wed = data.slice(216, 240);
				thu = data.slice(240, 264);
				fri = data.slice(264, 288);
				sat = data.slice(288, 312);
				sun = data.slice(312, 336);
				break;
				case 'delivery':
				mon = data.slice(336, 360);
				tue = data.slice(360, 384);
				wed = data.slice(384, 408);
				thu = data.slice(408, 432);
				fri = data.slice(432, 456);
				sat = data.slice(456, 480);
				sun = data.slice(480, 504);
				break;			
			}
		let mon2 = mon.filter((item, index)=> index > this.startSelected - 2).filter((item, index)=> index < this.endSelected - (this.startSelected - 1))
		let tue2 = tue.filter((item, index)=> index > this.startSelected - 2).filter((item, index)=> index < this.endSelected - (this.startSelected - 1))
		let wed2 = wed.filter((item, index)=> index > this.startSelected - 2).filter((item, index)=> index < this.endSelected - (this.startSelected - 1))
		let thu2 = thu.filter((item, index)=> index > this.startSelected - 2).filter((item, index)=> index < this.endSelected - (this.startSelected - 1))
		let fri2 = fri.filter((item, index)=> index > this.startSelected - 2).filter((item, index)=> index < this.endSelected - (this.startSelected - 1))
		let sat2 = sat.filter((item, index)=> index > this.startSelected - 2).filter((item, index)=> index < this.endSelected - (this.startSelected - 1))
		let sun2 = sun.filter((item, index)=> index > this.startSelected - 2).filter((item, index)=> index < this.endSelected - (this.startSelected - 1))
		
		this.coreWeekData.push(mon2, tue2, wed2, thu2, fri2, sat2, sun2)
		},
		async fetchGetLockerSlotsDesktop(){
			const {data} =	await SlotsRepo.getLockerSlots()
			this.weekOneLockerDateRange = moment(data[0][0].slotDate).format('D MMM') + " to " + moment(data[6][0].slotDate).format('D MMM')
			this.weekTwoLockerDateRange = moment(data[7][0].slotDate).format('D MMM') + " to " + moment(data[13][0].slotDate).format('D MMM')
			this.weekThreeLockerDateRange = moment(data[14][0].slotDate).format('D MMM') + " to " + moment(data[20][0].slotDate).format('D MMM')
			this.weekFourLockerDateRange = moment(data[21][0].slotDate).format('D MMM') + " to " + moment(data[27][0].slotDate).format('D MMM')
			
			this.weekOneLockerData = data.slice(0, 7)
			this.weekTwoLockerData = data.slice(7, 14)
			this.weekThreeLockerData = data.slice(14, 21)
			this.weekFourLockerData = data.slice(21)
	
		},
		async fetchGetDeliverySlotsDesktop(){
			const {data} =	await SlotsRepo.getDeliverySlots()
			this.weekOneDeliveryDateRange = moment(data[0][0].slotDate).format('D MMM') + " to " + moment(data[6][0].slotDate).format('D MMM')
			this.weekTwoDeliveryDateRange = moment(data[7][0].slotDate).format('D MMM') + " to " + moment(data[13][0].slotDate).format('D MMM')
			this.weekThreeDeliveryDateRange = moment(data[14][0].slotDate).format('D MMM') + " to " + moment(data[20][0].slotDate).format('D MMM')
			this.weekFourDeliveryDateRange = moment(data[21][0].slotDate).format('D MMM') + " to " + moment(data[27][0].slotDate).format('D MMM')

			this.weekOneDeliveryData = data.slice(0, 7)
			this.weekTwoDeliveryData = data.slice(7, 14)
			this.weekThreeDeliveryData = data.slice(14, 21)
			this.weekFourDeliveryData = data.slice(21)
	
		},
		showCustomerSlotConfirmationModal() {
			let slotDate = moment(this.selectedSlotDate).format('D MMM')
			this.$bvModal.msgBoxConfirm('' + this.selectedSlotDay + " " + slotDate + " " + this.selectedSlotTime, {
			title: 'Please Confirm your collection day and time',
			size: 'sm',
			buttonSize: 'sm',
			okVariant: 'danger',
			okTitle: 'Confirm',
			cancelTitle: 'Change',
			footerClass: 'p-2',
			hideHeaderClose: false,
			centered: true
			})
			.then((event) => {
			if(event)
			{
				this.formSubmitted = true
				this.postConfirmCustomerSlot()
			}
			})
			.catch(err => {
			// An error occurred
			console.warn(err)
			})		
		},
		async postConfirmCustomerSlot(){			
			var formData = new FormData();
			for ( var key in this.form ) {
				formData.append(key, this.form[key]);
			}	
				await SlotsRepoPost.postConfirmCustomerSlot(formData)
		}
	},
	filters : {
		getSlotTypeIcon: function(slotType){
			let abbreviation = "";
			switch(slotType)
			{
				case 'locker':
				abbreviation = "L";
				break;	
				case 'clickandcollect':
				abbreviation = "C";
				break;	
				case 'delivery':
				abbreviation = "D";
				break;
				
			}
			return abbreviation;
		},
		getSlotTypeText: function(slotType){
			let typeText = "";
			switch(slotType)
			{
				case 'locker':
				typeText = "Click&Collect Locker";
				break;	
				case 'clickandcollect':
				typeText = "Click&Collect Desk";
				break;	
				case 'delivery':
				typeText = "Delivery";
				break;
				
			}
			return typeText;
		},
		headerTitleText: function(text){
			let slotType = "Click&Collect desk "
			return text + slotType + "slot"
		},
		boolFilter: function(value){
			return (value == 1)? "Yes" : "No";
		},
		boolNaFilter: function(value){
			return (value == 0)? "N/A" : value
		}
	}
}